import { CedeSDKError } from "../errors";
import { sanitize } from "../sanitizer";
import * as Sentry from "@sentry/types";

export const filterSDKErrorBeforeSend = (originalException?: unknown): boolean => {
  if (originalException instanceof CedeSDKError) {
    return true;
  }
  return false;
};

export const sanitizeBeforeSend = (event: Sentry.Event): Sentry.Event => {
  if (event.extra) {
    event.extra = sanitize(event.extra as Record<string, unknown>);
  }
  if (event.contexts) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    event.contexts = sanitize(event.contexts as Record<string, unknown>);
  }
  return event;
};
